/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { VIDEOS_AVAILABLE_EVENT, VIDEO_COUNT_GLOBAL } from "../LoanAssist/LeadVideoNudge";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import classes from "./SideMenu.module.css";

import { makeStyles } from "@mui/styles";
import { Link, useLocation, useNavigate, useParams, useResolvedPath, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//images
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HomeIcon from "../Icons/Home";
import Tokens from "../Icons/Token";
import ListIcon from "../Icons/ListIcon";
import ChannelPartner from "../Icons/ChannelPartner";
import Services from "../Icons/Services";
import CPSelected from "../Icons/CPSelected";

import Logout from "../Icons/Logout";
import store from "../../Redux Store/store";

import { errorTost } from "../../Services/Toast";
import { getLoggedInUser } from "../../Services/OtpAuth";
import actions from "../../Redux Store/actions";
import { Box, useMediaQuery } from "@mui/material";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
// import { getCurrentUser } from "../../services/LoginService";
// mobile menu
import LogoIcon from "../../Assets/Images/SideMenu/vjLogo.jpg";
import DashboardIcon from "../../Assets/Images/SideMenu/Dashboard.svg";
import DashboardActiveIcon from "../../Assets/Images/SideMenu/DashboardActive.svg";
import TokenIcon from "../../Assets/Images/SideMenu/token.svg";
import AllotmentIcon from "../../Assets/Images/SideMenu/Allotments.svg";
import PreselectsIcon from "../../Assets/Images/SideMenu/preselect.svg";
import HelpIcon from "../../Assets/Images/SideMenu/Help.svg";
import SettingsIcon from "../../Assets/Images/SideMenu/Settings.svg";
import LogoutIcon from "../../Assets/Images/SideMenu/Logout.svg";
import ChangeUnitRequestsIcon from "../../Assets/Images/SideMenu/CancelUnit.svg";
import AllotmentActiveIcon from "../../Assets/Images/SideMenu/AllotmentsActive.svg";
import HelpActiveIcon from "../../Assets/Images/SideMenu/HelpActive.svg";
import TokenActiveIcon from "../../Assets/Images/SideMenu/TokenActive.svg";
import ChangeUnitRequestsActiveIcon from "../../Assets/Images/SideMenu/CancelUnitActive.svg";
import PreselectsActiveIcon from "../../Assets/Images/SideMenu/PreselecActive.svg";
import SettingsActiveIcon from "../../Assets/Images/SideMenu/SettingsActive.svg";
import TransactionsActiveIcon from "../Icons/Transaction";
import BankIcon from "../Icons/Bank";
import { logOut } from "../../Services/Login";
import { useHasCrm2Booking } from "../Home/Crm2/crm2Stage";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const useStyles = makeStyles((theme) => ({
	menu_item: {
		marginBottom: "0.8rem",

		"&:hover": {
			borderRadius: "0.6rem !important",
			background: "#F8FAFC !important",
			fontWeight: "600",
		},
		// border:"none! important",
		// background:"#FFFFF !important"
	},
	icon: {
		minWidth: "3rem !important",
		marginRight: "1.5rem",
	},
	menu: {
		margin: "0",
		"& span": {
			display: "inline-block",
			fontFamily: "Inter-Regular",
			fontSize: "1.8rem",
			lineHeight: "2.8rem",
			color: "#64748B",
			fontWeight: "500",
			letterSpacing: "-0.01em",
			"&:hover": {
				color: "#0F172A !important",
				fontWeight: "600",
				fontFamily: "Inter-Regular",
			},
		},
		"&:hover": {
			color: "#0F172A !important",
			fontWeight: "600",
		},
	},
	active: {
		background: "#EFF8FF !important",
		color: "#1570EF !important",
		borderRadius: "8px !important",
		"& span": {
			color: "#1570EF",
			fontWeight: "600",
			// background: "#1570EF"
			"&:hover": {
				color: "#1570EF !important",
			},
		},
		"&:hover": {
			background: "#F8FAFC !important",
			color: "#1570EF !important",
		},
	},
	user_avatar: {
		display: "inline-block !important",
		marginRight: "1.2rem !important",
		verticalAlign: "middle !important",
		width: "4rem !important",
		height: "4rem !important",
		borderRadius: "100%!important",
		objectFit: "contain",
	},
	speed_dial: {
		// position: 'absolute',
		// left: '50%',
		// background: "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% )",
		"& .MuiSpeedDial-fab": {
			background: "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% ) !important",
		},
		"& .MuiSpeedDialIcon-icon": {
			width: "3rem",
			height: "3rem",
		},
		"& .MuiSpeedDialAction-staticTooltipLabel": {
			fontSize: "1.6rem !important",
			lineHeight: "1.6rem !important",
			fontFamily: "Inter-Regular !important",
			wordBreak: "unset !important",
			boxShadow: "0px 2rem 2.4rem -0.4rem rgb(16 24 40 / 8%), 0px 0.8rem 0.8rem -0.4rem rgb(16 24 40 / 3%) !important",
			border: "1px solid #eaecf0 !important",
			background: "#D1E9FF",
			color: "rgb(23, 92, 211)",
		},
		"& .MuiSpeedDialAction-fab": {
			boxShadow: "0px 2rem 2.4rem -0.4rem rgb(16 24 40 / 8%), 0px 0.8rem 0.8rem -0.4rem rgb(16 24 40 / 3%) !important",
		},
		"& .MuiSpeedDialAction-fab > svg": {
			width: "3rem",
			height: "3rem",
			color: "#fff",
		},
	},
	add_lead_menu: {
		background: "linear-gradient(136.4deg,rgba(23, 92, 211, 1) 0%,rgba(74, 139, 233, 1) 100% ) !important",
	},
}));
function SideMenu({ props }) {
	const classList = useStyles();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);
	const [index, setIndex] = useState(0);
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const isWrap = useMediaQuery("(max-width:1024px)");
	const isBottomNav = useMediaQuery("(min-width:900px)");
	// CRM 2.0 (M3.17): "Allotments" reads "My Units" once the customer has a CRM 2.0 booking
	const hasCrm2Booking = useHasCrm2Booking();
	const menuName = (m) => (m.tabName === "allotments" && hasCrm2Booking ? "My Units" : m.name);
	const [menuArray, setMenuArray] = useState([
		{
			icon: <img src={DashboardIcon} alt="dashboard" />,
			activeIcon: <img src={DashboardActiveIcon} alt="dashboard" />,
			name: "Dashboard",
			tabName: "dashboard",
			isVisible: true,
			path: "/Home/Dashboard",
		},
		{
			icon: <img src={TokenIcon} alt="token" />,
			activeIcon: <img src={TokenActiveIcon} alt="token" />,
			name: "Tokens",
			tabName: "tokens",
			isVisible: true,
			path: "/Home/Tokens",
		},
		{
			icon: <img src={AllotmentIcon} alt="allotments" />,
			activeIcon: <img src={AllotmentActiveIcon} alt="allotments" />,
			name: "Allotments",
			tabName: "allotments",
			isVisible: true,
			path: "/Home/Allotments",
		},
		{
			icon: <img src={PreselectsIcon} alt="preselect" />,
			activeIcon: <img src={PreselectsActiveIcon} alt="Prselect" />,
			name: "Pre-select Confirmations",
			tabName: "preselect",
			isVisible: true,
			path: "/Home/PreselectConfirmations",
		},
		{
			icon: <DescriptionOutlinedIcon style={{ color: "#64748B" }} />,
			activeIcon: <DescriptionOutlinedIcon style={{ color: "#1570EF" }} />,
			name: "Documents",
			tabName: "documents",
			isVisible: true,
			path: "/Home/Documents",
		},
		{
			icon: <img src={ChangeUnitRequestsIcon} alt="cancelunit" />,
			activeIcon: <img src={ChangeUnitRequestsActiveIcon} alt="cancelunit" />,
			name: "Cancel Unit Requests",
			tabName: "cancelunits",
			isVisible: true,
			path: "/Home/CancelUnitsRequest",
		},
		{
			icon: <TransactionsActiveIcon color="#64748B" />,
			activeIcon: <TransactionsActiveIcon color="#1570EF" />,
			name: "Transactions",
			tabName: "transactions",
			isVisible: true,
			path: "/Home/Transaction",
		},
		{
			icon: <BankIcon color="#64748B" />,
			activeIcon: <BankIcon color="#1570EF" />,
			name: "Loan Assist",
			tabName: "loanassist",
			isVisible: true,
			path: "/Home/LoanAssist",
		},
		{
			icon: <BankIcon color="#64748B" />,
			activeIcon: <BankIcon color="#1570EF" />,
			name: "E-Mandate",
			tabName: "emandateallotments",
			isVisible: true,
			path: "/Home/EMandate",
		},
		{
			icon: <PlayCircleOutlineIcon sx={{ color: "#64748B" }} />,
			activeIcon: <PlayCircleOutlineIcon sx={{ color: "#1570EF" }} />,
			name: "Tutorials",
			tabName: "leadvideos",
			isVisible: true,
			path: "/Home/Tutorials",
		},
		
	]);
	// The onboarding videos live in a modal, not a route. LeadVideoNudge (mounted
	// in the Mainpage layout) owns them and broadcasts how many this lead has, so
	// the menu item only appears for customers who actually have videos. The
	// window value covers the case where this menu mounted before that fetch.
	const [hasLeadVideos, setHasLeadVideos] = useState(
		typeof window !== "undefined" && Number(window[VIDEO_COUNT_GLOBAL]) > 0
	);

	useEffect(() => {
		const onAvailability = (e) => {
			setHasLeadVideos(Number(e && e.detail && e.detail.count) > 0);
		};
		window.addEventListener(VIDEOS_AVAILABLE_EVENT, onAvailability);
		return () => window.removeEventListener(VIDEOS_AVAILABLE_EVENT, onAvailability);
	}, []);

	const [settingsArray, setSettingsArray] = useState([
		// {
		//   icon: <PrivacyPolicy color={'#84CAFF'}/>,
		//   activeIcon: <PrivacyPolicy color={'#FFFFFF'}/>,
		//   name: "Privacy Policy",
		//   tabName: "privacypolicy",
		//   isVisible: true,
		//   path: "/Home/PrivacyPolicy",
		//   show: true,
		// },
		// {
		//   icon: <TermsAndConditions color={'#84CAFF'}/>,
		//   activeIcon: <TermsAndConditions color={'#FFFFFF'}/>,
		//   name: "Terms And Conditions",
		//   tabName: "termsandcondition",
		//   isVisible: true,
		//   path: "/Home/TermsAndConditions",
		//   show: true,
		// },
		// {
		//   icon: <Services color={'#84CAFF'}/>,
		//   activeIcon: <Services color={'#FFFFFF'}/>,
		//   name: "Services Offered",
		//   tabName: "servicesoffered",
		//   isVisible: true,
		//   path: "/Home/Services",
		//   show: true,
		// },
		// {
		//   icon: <RefundPolicy color={'#84CAFF'}/>,
		//   activeIcon: <RefundPolicy color={'#FFFFFF'}/>,
		//   name: "Cancellation/Refund Policy",
		//   tabName: "cancellationpolicy",
		//   isVisible: true,
		//   path: "/Home/CancellationPolicy",
		//   show: true,
		// },
		// {
		//   icon: <ContactUs color={'#60A5FA'}/>,
		//   activeIcon: <ContactUs color={'#60A5FA'}/>,
		//   name: "Contact Us",
		//   tabName: "contactus",
		//   isVisible: true,
		//   path: "/Home/ContactUs",
		//   show: true,
		// },
		// {
		//   icon: <AboutUs color={'#84CAFF'}/>,
		//   activeIcon: <AboutUs color={'#FFFFFF'}/>,
		//   name: "About Us",
		//   tabName: "aboutus",
		//   isVisible: true,
		//   path: "/Home/AboutUs",
		//   show: true,
		// },
		{
			icon: <img src={HelpIcon} alt={"help"} />,
			activeIcon: <img src={HelpActiveIcon} alt={"help"} />,
			name: "Help",
			tabName: "help",
			isVisible: true,
			path: "/Home/Help",
			show: true,
		},
		{
			icon: <img src={SettingsIcon} alt={"setting"} />,
			activeIcon: <img src={SettingsActiveIcon} alt={"setting"} />,
			name: "Settings",
			tabName: "profile",
			isVisible: true,
			path: "/Home/Profile",
			show: true,
		},
		{
			icon: <img src={LogoutIcon} alt={"logout"} />,
			activeIcon: <img src={LogoutIcon} alt={"logout"} />,
			name: "Logout",
			tabName: "logout",
			isVisible: true,
			path: "/Home/Help",
			show: true,
		},
	]);

	async function logoutUser() {
		await store.dispatch(actions.authLogout());
		setTimeout(() => {
			logOut()
				.then(({ err }) => {
					if (err) {
						errorTost(err);
					} else {
						// store.dispatch(actions.authLogout());
						localStorage.removeItem("supabase.auth.token");
						localStorage.removeItem("LeadList");
						localStorage.removeItem("selectedLead");
						// navigate("/");
					}
				})
				.catch((error) => {
					errorTost(error);
				})
				.finally(() => {
					store.dispatch(actions.authLogout());
					navigate("/");
				});
		}, 1000);

		// logOut()
		// 	.then(({ err }) => {
		// 		if (err) {
		// 			errorTost(err);
		// 		} else {
		// 			store.dispatch(actions.authLogout());
		// 			localStorage.removeItem("supabase.auth.token");
		// 			localStorage.removeItem("LeadList");
		// 			localStorage.removeItem("selectedLead");
		// 			// navigate("/");
		// 		}
		// 	})
		// 	.catch((error) => {
		// 		errorTost(error);
		// 	}).finally(() => {
		// 		store.dispatch(actions.authLogout());
		// 		navigate("/");
		// 	});

		// signOut()
		//   .then(({ err }) => {
		//     if (err) {
		//       errorTost(err);
		//     } else {
		// store.dispatch(actions.authLogout());
		// navigate("/");
		//     }
		//   })
		//   .catch((error) => {
		//     errorTost(error);
		//   });
	}
	return (
		<>
			{!isWrap && (
				<div className={classes.wrapper}>
					<div>
						<div className={classes.app_info}>
							{/* <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={()=>{
              props(!props);
            }}
            // sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon sx={{
              color:'#FFFFFF',
              fontSize:'3rem'
            }}/>
          </IconButton> */}

							<div className={classes.app_logo}>
								<img src={LogoIcon} alt="logo" className={classes.sideMenuLogo} />
							</div>
							{/* <div className={classes.app_name}>App Name</div> */}
						</div>
						<div className={classes.menu_array}>
							<List>
								{menuArray
									.filter((menu) => menu.tabName !== "leadvideos" || hasLeadVideos)
									// CRM 2.0 (M3.49): Documents only for customers with a CRM 2.0 booking
									.filter((menu) => menu.tabName !== "documents" || hasCrm2Booking)
									.map((menu, index) => (
									<div
										to={menu.path}
										key={`MenuArray_${index}`}
										onClick={(e) => {
											dispatch(actions.activeMenu(menu.tabName));
											navigate(menu.path);
											sessionStorage.clear();
										}}
									>
										<ListItem
											button
											key={menu.tabName}
											className={classList.menu_item}
											selected={activeMenu === menu.tabName.toLowerCase()}
											classes={{ selected: classList.active }}
										>
											<ListItemIcon className={classList.icon}>
												{activeMenu === menu.tabName.toLowerCase() ? menu.activeIcon : menu.icon}

												{/* <img
                        src={
                          activeMenu === menu.tabName.toLowerCase()
                            ? menu.activeIcon
                            : menu.icon
                        }
                        alt={menu.name}
                      /> */}
											</ListItemIcon>
											<ListItemText primary={menuName(menu)} className={classList.menu} />
										</ListItem>
									</div>
								))}
							</List>
						</div>
					</div>
					<div className={classes.settingArr}>
						<List
							style={{
								overflow: "auto",
							}}
						>
							{settingsArray.map((menu, index) => (
								<div
									to={menu.path}
									key={`MenuArray_${index}`}
									onKeyDown={(e) => {
										navigate(menu.path);
									}}
									onClick={(e) => {
										if (menu.name === "Logout") {
											logoutUser();
											localStorage.setItem("ModalFlag", JSON.stringify(true));
										} else {
											navigate(menu.path);
										}
									}}
								>
									<ListItem
										button
										key={menu.tabName}
										className={classList.menu_item}
										selected={activeMenu === menu.tabName.toLowerCase()}
										classes={{ selected: classList.active }}
									>
										<ListItemIcon className={classList.icon}>
											{activeMenu === menu.tabName.toLowerCase() ? menu.activeIcon : menu.icon}
										</ListItemIcon>
										<ListItemText primary={menuName(menu)} className={classList.menu} />
									</ListItem>
								</div>
							))}
						</List>
					</div>
					{/* <Divider
            sx={{
              borderColor: "#1570EF",
            }}
          />
          <div className={classes.user_profile}>
            {loggedInUser?.profileImgUrl ? (
              <img
                src={
                  process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                  loggedInUser?.profileImgUrl +
                  `?${Date.now()}`
                }
                alt=""
                id="profilePhoto"
                className={classList.user_avatar}
              />
            ) : (
              <AccountCircleOutlinedIcon
                sx={{
                  width: "12%",
                  height: "12%",
                  color: "#FFFFFF",
                  marginRight: "1.2rem",
                }}
              />
            )}

            <div
              className={classes.user_info}
              onClick={(e) => {
                navigate("/Home/Profile");
              }}
            >
              {loggedInUser && (
                <>
                  <div
                    className={classes.user_name}
                    title={loggedInUser?.personId?.name}
                  >
                    {loggedInUser?.personId?.name}
                  </div>
                  <div
                    className={classes.user_email}
                    title={loggedInUser?.personId?.contactNumber}
                  >
                    +{loggedInUser?.personId?.contactNumber}
                  </div>
                </>
              )}
            </div>
            <div
              className={classes.logout}
              tabIndex={0}
              onClick={logoutUser}
              title="Logout"
              onKeyDown={(e) => {
                if (e.keyCode === 32 || e.keyCode === 13) {
                  logoutUser();
                }
              }}
            >
              {<Logout color='#fff' />}
            </div>
          </div> */}
				</div>
			)}
			{isWrap && (
				<Box
					sx={{
						borderRadius: "1.3rem 1.3rem 0 0",
						bgcolor: "#fff",
						boxShadow: "0px 0px 15px rgb(73 83 211 / 5%)",
						height: isBottomNav ? "10vh" : "8vh",
					}}
				>
					<Tabs
						sx={{
							width: "100%",
							height: "100%",
							boxShadow: "0px 0px 15px rgba(73, 83, 211, 0.08)",
							justifyContent: "center",
							overflowX: "auto",
							"&::-webkit-scrollbar": {
								display: "none",
							},
						}}
						size="lg"
						aria-label="Bottom Navigation"
						value={index}
						onChange={(event, value) => setIndex(value)}
						// sx={(theme) => ({
						//   borderBottomLeftRadius: '1rem',
						//   borderBottomRightRadius: '1rem',
						//   maxWidth: 400,
						//   mx: 'auto',
						//   boxShadow: theme.shadow.sm,
						//   '--Tabs-gap': '8px',
						//   '--joy-shadowChannel': theme.vars.palette[colors[index]].darkChannel,
						//   [`& .${tabClasses.root}`]: {
						//     boxShadow: 'none',
						//     borderRadius: 'lg',
						//     whiteSpace: 'nowrap',
						//     transition: '0.3s',
						//     fontWeight: 'lg',
						//     flex: 1,
						//     [`&:not(.${tabClasses.selected}):not(:hover)`]: {
						//       opacity: 0.72,
						//     },
						//   },
						// })}
					>
						<TabList variant="plain" sx={{ padding: "0" }}>
							<Tab
								orientation="vertical"
								sx={{
									color: activeMenu === "Dashboard" ? "#175cd3" : "#98A2B3",
									"&:hover": {
										color: "#175cd3",
									},
								}}
								className={classes.mobile_menu}
								onClick={(e) => {
									dispatch(actions.activeMenu("dashboard"));
									navigate("/Home/Dashboard");
								}}
							>
								<ListItemDecorator>
									{activeMenu === "dashboard" ? (
										<img src={DashboardActiveIcon} alt="dashboard" />
									) : (
										<img src={DashboardIcon} alt="dashboard" />
									)}
								</ListItemDecorator>
								Dashboard
							</Tab>
							<Tab
								orientation="vertical"
								sx={{
									color: activeMenu === "token" ? "#175cd3" : "#98A2B3",
									"&:hover": {
										color: "#175cd3",
									},
								}}
								className={classes.mobile_menu}
								onClick={(e) => {
									dispatch(actions.activeMenu("tokens"));
									navigate("/Home/Tokens");
								}}
							>
								<ListItemDecorator>
									{activeMenu === "tokens" ? <img src={TokenActiveIcon} alt="token" /> : <img src={TokenIcon} alt="token" />}
									{/* {activeMenu === "tokens" ? (
                    <img src={TokensIcon} alt="Tokens" color='#28303F' />
                  ) : (
                    <img src={TokensIcon} alt="Tokens" color="#98A2B3" />
                  )} */}
								</ListItemDecorator>
								Tokens
							</Tab>
							<Tab
								orientation="vertical"
								sx={{
									color: activeMenu === "allotments" ? "#175cd3" : "#98A2B3",
									"&:hover": {
										color: "#175cd3",
									},
								}}
								className={classes.mobile_menu}
								onClick={(e) => {
									dispatch(actions.activeMenu("allotments"));
									navigate("/Home/Allotments");
								}}
							>
								<ListItemDecorator>
									{activeMenu === "allotments" ? (
										<img src={AllotmentActiveIcon} alt="allotments" />
									) : (
										<img src={AllotmentIcon} alt="allotments" />
									)}
									{/* {activeMenu === "allotments" ? (
                    <img src={AllotmentsIcon} alt="Allotments" color='#28303F' />
                  ) : (
                    <img src={AllotmentsIcon} alt="Allotments" color="#98A2B3" />
                  )} */}
								</ListItemDecorator>
								Allotments
							</Tab>
							<Tab
								orientation="vertical"
								sx={{
									color: activeMenu === "transactions" ? "#175cd3" : "#98A2B3",
									"&:hover": {
										color: "#175cd3",
									},
								}}
								className={classes.mobile_menu}
								onClick={(e) => {
									dispatch(actions.activeMenu("transactions"));
									navigate("/Home/Transaction");
								}}
							>
								<ListItemDecorator>
									{activeMenu === "transactions" ? (
										<TransactionsActiveIcon color="#1570EF" />
									) : (
										<TransactionsActiveIcon color="#64748B" />
									)}
								</ListItemDecorator>
								Transactions
							</Tab>
							
							<Tab
								orientation="vertical"
								sx={{
									color: activeMenu === "loanassist" ? "#175cd3" : "#98A2B3",
									"&:hover": {
										color: "#175cd3",
									},
								}}
								className={classes.mobile_menu}
								onClick={(e) => {
									dispatch(actions.activeMenu("loanassist"));
									navigate("/Home/LoanAssist");
								}}
							>
								<ListItemDecorator>
									{activeMenu === "loanassist" ? (
										<BankIcon color="#1570EF" />
									) : (
										<BankIcon color="#64748B" />
									)}
								</ListItemDecorator>
								Loan Assist
							</Tab>
							{hasLeadVideos && (
								<Tab
									orientation="vertical"
									sx={{
										color: activeMenu === "leadvideos" ? "#175cd3" : "#98A2B3",
										"&:hover": {
											color: "#175cd3",
										},
									}}
									className={classes.mobile_menu}
									onClick={() => {
										dispatch(actions.activeMenu("leadvideos"));
										navigate("/Home/Tutorials");
									}}
								>
									<ListItemDecorator>
										<PlayCircleOutlineIcon
											sx={{ color: activeMenu === "leadvideos" ? "#1570EF" : "#64748B" }}
										/>
									</ListItemDecorator>
									Tutorials
								</Tab>
							)}
							<Tab
								orientation="vertical"
								sx={{
									color: activeMenu === "emandateallotments" ? "#175cd3" : "#98A2B3",
									"&:hover": {
										color: "#175cd3",
									},
								}}
								className={classes.mobile_menu}
								onClick={(e) => {
									dispatch(actions.activeMenu("emandateallotments"));
									navigate("/Home/EMandate");
								}}
							>
								<ListItemDecorator>
									{activeMenu === "emandateallotments" ? (
										<BankIcon color="#1570EF" />
									) : (
										<BankIcon color="#64748B" />
									)}
								</ListItemDecorator>
								E-Mandate
							</Tab>
						</TabList>
					</Tabs>
				</Box>
			)}
		</>
	);
}
export default SideMenu;
